import * as React from "react";
import { useRef, useState } from "react";
import { Form, RadioButtonGroupInput, useLogin, useNotify } from "react-admin";
import { Card, CardContent, Button, TextField, Typography, Box, styled } from "@mui/material";
import { settings } from "app";
import { tenantLoginConfig } from "utils/tenants";
import { accountRequests } from "api/accountApi";
import "altcha";

const config = tenantLoginConfig[settings.tenant];

const StyledLoginPage = styled(Box)({
  backgroundImage: config.background,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
});

const StyledLoginCard = styled(Card)({
  backgroundColor: "#fff",
  width: "460px",
  borderRadius: "4px",
});

const StyledCardContent = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "32px",
});

const LoginPagePassword = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const altchaRef = useRef(null);
  const login = useLogin();
  const notify = useNotify();

  const handleSubmit = async ({ accountType }) => {
    if (!username || !password) {
      notify("Моля, въведете имейл и парола", { type: "warning" });
      return;
    }

    let altchaPayload;
    try {
      const result = await altchaRef.current?.verify();
      altchaPayload = result?.payload;
    } catch (error) {
      console.error("Altcha verification failed", error);
      altchaRef.current?.reset?.();
    }

    if (!altchaPayload) {
      notify("Моля, изчакайте проверката за сигурност", { type: "warning" });
      return;
    }

    login({ username, password, altchaPayload, accountType }).catch(() => {
      notify("Грешка при влизане в системата", { type: "error" });
      altchaRef.current?.reset?.();
    });
  };

  return (
    <StyledLoginPage>
      <StyledLoginCard>
        <StyledCardContent>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <img
              src={config.logo}
              alt="university-logo"
              style={{ height: "90px", objectFit: "contain" }}
            />
          </Box>

          <Typography
            variant="body1"
            sx={{ textAlign: "center", fontWeight: "bold", color: config.titleColor || config.subTitleColor }}
          >
            Добре дошли в административния панел на {config.title}.
          </Typography>

          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: config.subTitleColor }}
          >
            Моля, впишете се със служебните си данни за вход.
          </Typography>

          <Form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <TextField
                label="Потребителско име"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                fullWidth
                size="small"
                autoComplete="username"
              />

              <TextField
                label="Парола"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                fullWidth
                size="small"
                autoComplete="current-password"
              />

              <altcha-widget
                ref={altchaRef}
                challenge={accountRequests.getAltchaChallenge()}
                display="invisible"
              />

              <RadioButtonGroupInput
                label="Изберете тип на акаунт:"
                source="accountType"
                defaultValue="ldap"
                choices={[
                  { id: 'ldap', name: 'Домейн потребител' },
                  { id: 'local', name: 'Локален потребител' },
                ]} />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 1,
                  background: config.subTitleColor,
                  "&:hover": { background: config.titleColor || config.subTitleColor },
                }}
              >
                Вход
              </Button>
            </Box>
          </Form>
        </StyledCardContent>
      </StyledLoginCard>
    </StyledLoginPage>
  );
};

export default LoginPagePassword;